import RouteName from '@/models/enums/RouteName'
import CRMPermission from '@/models/enums/permissions/CRMPermission'

export default [
  {
    path: '/administration/payment-accounts',
    name: RouteName.AdministrationPaymentAccounts,
    component: () => import('@/pages/Administration/PaymentAccounts/PaymentAccountList.vue'),
    meta: {
      permissions: [CRMPermission.ViewAdministrationBilling],
      breadcrumb: {
        label: 'Платёжные аккаунты',
        parent: RouteName.Administration,
      },
    },
  },
  {
    path: '/administration/payment-accounts/:id',
    name: RouteName.AdministrationPaymentAccountCard,
    component: () => import('@/pages/Administration/PaymentAccounts/PaymentAccountCard.vue'),
    meta: {
      permissions: [CRMPermission.ViewAdministrationBilling],
      breadcrumb: {
        label: 'Счёт',
        parent: RouteName.AdministrationPaymentAccounts,
      },
    },
  },
]
